<template>
    <div class='g-signin-button row' ref='GSignInBtn' v-on:click="googleSigninLoading = true">
      <div class=" col-xs-8 col-xs-offset-2 csp-no-pad"><slot></slot></div>
      <transition name="fade">
        <div class="col-xs-2 csp-no-pad" v-if="googleSigninLoading">
          <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
          <span class="sr-only">Loading...</span>
        </div>
      </transition>
    </div>
</template>

<script>
export default {
  name: 'g-signin-button',
  props: {
    params: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    googleSigninLoading: {
      get: function () {
        return this.$store.getters.googleSigninLoading
      },
      set: function (nevValue) {
        this.$store.commit('setGoogleSigninLoading', nevValue)
      }
    }
  },
  mounted () {
    if (!window.gapi) {
      console.error('"https://apis.google.com/js/api:client.js" needs to be included as a <script>.')
      return
    }

    if (!this.params.client_id) {
      console.error('params.client_id must be specified.')
      return
    }

    window.gapi.load('auth2', () => {
      const auth2 = window.gapi.auth2.init(this.params)
      auth2.attachClickHandler(this.$refs.GSignInBtn, {}, googleUser => {
        this.$emit('success', googleUser)
      }, error => {
        this.$emit('error', error)
        this.$emit('failure', error) // an alias
      })
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Google.vue?20d0ff8a